import React, { useState } from "react";
import AddBtn from "../../Assets/addIcon.png";
import vegIcon from "../../Assets/vegan.png";
import RemoveBtn from "../../Assets/removeIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { addItem, removeItem } from "../../redux/action";
import { canOrderItem } from "../../Utills/menuAvailability";

const SelectItem = ({ id, tab, unit, disabled = false }) => {
  const menu = useSelector(state => state.user.menu);
  console.log("unit", unit);
  const quantity = unit ? unit.selected : 0;
  const dispatch = useDispatch();
  const handleIncrement = () => {
    const item = menu?.categories?.flatMap(category => category.items || []).find(value => value.menuId === (unit?.id || id));
    if (disabled || !canOrderItem(item)) return;
    dispatch(addItem({ id: id, selectedTab: tab }));
  };

  const handleDecrement = () => {
    dispatch(removeItem({ id: id, selectedTab: tab }));
  };

  return (
    <>
      {quantity === 0 && !disabled ? (
        /* --- FIRST TIME LOAD / NO ITEMS ADDED --- */
        <button
          type="button"
          className="singleAddBtn"
          onClick={handleIncrement}
          aria-label={`Add ${unit?.foodName || "item"} to cart`}
        >
          ADD +
        </button>
      ) : (
        <>
          <button
            type="button"
            className="quantityActionBtn"
            onClick={handleDecrement}
            aria-label={`Decrease ${unit?.foodName || "item"} quantity`}
          >
            <img src={RemoveBtn} alt="" className="addRemoveIcon" />
          </button>
          {unit && (
            <div className="selectNum" aria-live="polite" aria-label={`Quantity ${unit.selected}`}>
              <div>{unit.selected}</div>
            </div>
          )}
          {unit && !disabled && (
            <button
              type="button"
              className="quantityActionBtn"
              onClick={handleIncrement}
              aria-label={`Increase ${unit?.foodName || "item"} quantity`}
            >
              <img src={AddBtn} alt="" className="addRemoveIcon" />
            </button>
          )}
        </>
      )}
    </>
  );
};

export default SelectItem;
